import React from "react";
import styled from "styled-components";
import { LoginLogoutAccountStyle } from "../common";
import { HomeLink } from "../Navigation/partials";

const AccountTopNavWrapper = styled.div`
  width: 100%;
  position: relative;

  ${HomeLink} {
    position: absolute;
  }

  @media print {
    display: none;
  }
`;

const AccountLogoutButton = styled.button`
  ${LoginLogoutAccountStyle}
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 5;
  right: -80px;
  top: 30px;
  text-align: left;
  text-transform: none;
  font-size: 20px;
  font-weight: 700;
  width: 230px;
`;
export const AccountTopNav = ({ signOut }) => {
  return (
    <AccountTopNavWrapper>
      <HomeLink to="/">
        <span className="sr-only">Till startsidan</span>
      </HomeLink>
      <AccountLogoutButton onClick={signOut} type="button">
        Logga ut
      </AccountLogoutButton>
    </AccountTopNavWrapper>
  );
};
